var DateRangeBoundary = {
  Start: "start",
  End: "end"
};

export { DateRangeBoundary };
